import { useState, useEffect } from "react";
import { Download, X } from "lucide-react";

export default function InstallPWAPrompt() {
  var deferredState = useState(null);
  var deferred = deferredState[0];
  var setDeferred = deferredState[1];
  var showState = useState(false);
  var show = showState[0];
  var setShow = showState[1];
  var dismissedState = useState(false);
  var dismissed = dismissedState[0];
  var setDismissed = dismissedState[1];

  useEffect(function() {
    var alreadyInstalled = window.matchMedia("(display-mode: standalone)").matches;
    if (alreadyInstalled) return;

    var wasDismissed = sessionStorage.getItem("pwa-dismissed");
    if (wasDismissed) {
      setDismissed(true);
      return;
    }

    function handler(e) {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    }
    window.addEventListener("beforeinstallprompt", handler);
    return function() { window.removeEventListener("beforeinstallprompt", handler); };
  }, []);

  async function handleInstall() {
    if (!deferred) return;
    deferred.prompt();
    var result = await deferred.userChoice;
    if (result.outcome === "accepted") {
      setShow(false);
    }
    setDeferred(null);
  }

  function handleDismiss() {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem("pwa-dismissed", "true");
  }

  if (!show || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 lg:left-auto lg:right-6 lg:bottom-6 lg:w-96" data-testid="pwa-install-prompt">
      <div className="bg-[#0A2F3D] rounded-2xl shadow-2xl border border-white/10 p-4 flex items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-[#3B82F6]/20 flex items-center justify-center flex-shrink-0">
          <Download className="w-6 h-6 text-[#3B82F6]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-semibold text-sm">Instalar Methos App</p>
          <p className="text-white/50 text-xs">Acesse rapido direto da sua tela inicial</p>
        </div>
        <button
          onClick={handleInstall}
          className="px-4 py-2 bg-[#3B82F6] text-white text-sm font-semibold rounded-xl hover:bg-[#2563EB] transition-colors flex-shrink-0"
          data-testid="pwa-install-btn"
        >
          Instalar
        </button>
        <button
          onClick={handleDismiss}
          className="p-1.5 text-white/40 hover:text-white/80 transition-colors flex-shrink-0"
          data-testid="pwa-dismiss-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
